import Cookies from 'js-cookie'

/**
 * EMR issues a Sanctum personal access token for the professional guard. The
 * portal keeps it here and sends it as a Bearer header. Same cookie name and
 * encoding as ainsights-professional, so a session survives a switch between
 * the two apps on the same host.
 *
 * Note the corollary: the cookie is keyed by host, not port, so v1 on :1411 and
 * v2 on :1414 overwrite each other's token. Use separate browser profiles when
 * running both.
 */
export const AUTH_COOKIE_NAME = 'professional_auth_token'

export function getAuthCookie(): string | null {
  const cookie = Cookies.get(AUTH_COOKIE_NAME)
  if (!cookie) return null

  try {
    return JSON.parse(atob(cookie)) as string
  } catch {
    return null
  }
}

export function setAuthCookie(value: string): void {
  Cookies.set(AUTH_COOKIE_NAME, btoa(JSON.stringify(value)), {
    // Keyed off the actual scheme rather than hardcoded: a Secure cookie is
    // silently dropped over plain http, which would break local dev in browsers
    // that don't treat localhost as a secure context.
    secure: window.location.protocol === 'https:',
    sameSite: 'lax',
  })
}

export function removeAuthCookie(): void {
  Cookies.remove(AUTH_COOKIE_NAME)
}
